import React, { useState } from "react";
import { LuSparkles } from "./icons";
import { supabase } from "../../config/Supabase";
import "../../styles/Quiz.css";

// Email-capture gate shown before quiz results (Quiz.js / DoshaQuiz.js). Inserts
// into Supabase `quiz_leads` (public anon INSERT — see
// supabase/migrations/20260727000001_public_lead_forms.sql). Styled to match the
// premium quiz aesthetic (Quiz.css).
const SubscriptionForm = ({ onFormSubmit }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validateForm = () => {
    const next = {};
    if (!name) next.name = "Please enter your name.";
    if (!email) next.email = "Please enter your email.";
    else if (!/\S+@\S+\.\S+/.test(email)) next.email = "Email is not valid.";
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setSubmitting(true);
    try {
      const { error: insertError } = await supabase.from("quiz_leads").insert({
        name: name.trim(),
        email: email.trim().toLowerCase(),
        phone: phone.trim() || null,
        source: window.location.pathname,
      });
      if (insertError) throw insertError;
      if (onFormSubmit) onFormSubmit();
    } catch (error) {
      console.error("Error saving lead: ", error);
      setErrors({ email: "Something went wrong. Please try again." });
      setSubmitting(false);
    }
  };

  return (
    <div className="quiz-lead-form">
      <span className="quiz-lead-form__icon" aria-hidden="true">
        <LuSparkles />
      </span>
      <h2 className="quiz-lead-form__title">See your results</h2>
      <p className="quiz-lead-form__sub">
        Enter your details and we'll reveal your personalized result — plus a few natural tips
        to get started.
      </p>

      <form onSubmit={handleSubmit} noValidate>
        <div className="quiz-field">
          <input
            type="text"
            className={`quiz-input${errors.name ? " quiz-input--error" : ""}`}
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          {errors.name && <span className="quiz-field__error">{errors.name}</span>}
        </div>

        <div className="quiz-field">
          <input
            type="email"
            className={`quiz-input${errors.email ? " quiz-input--error" : ""}`}
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {errors.email && <span className="quiz-field__error">{errors.email}</span>}
        </div>

        <div className="quiz-field">
          <input
            type="tel"
            className="quiz-input"
            placeholder="Phone number (optional)"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <button
          type="submit"
          className="quiz-btn quiz-btn--primary quiz-btn--block"
          disabled={submitting}
        >
          {submitting ? "Loading…" : "Show my results →"}
        </button>

        <p className="quiz-lead-form__consent">
          By submitting, I consent to Sarv and its affiliates contacting me by email at the
          address provided and/or by telephone at the number provided (by live, automated, or
          prerecorded phone calls or text messages) about its products and services.
        </p>
      </form>
    </div>
  );
};

export default SubscriptionForm;
